import { colors, theme, typography } from '@kijiji/theme'
import { Flex } from '@kijiji/ui'
import styled from 'styled-components'

import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { Button } from '@/ui/atoms/button'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'
import { styleFromTypography } from '@/ui/helpers/styleFromTypography'

export const QuickFilterButtonStyles = styled(Button)`
  min-width: 12rem;
  max-width: 18rem;
  max-height: 4rem;
`

export const AllFiltersButtonStyles = styled(Button)`
  max-height: 4rem;
  position: relative;
`

export const QuickFilterButtonText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  flex-grow: 1;
  font-weight: ${theme.fontWeight.regular};
`

export const QuickFiltersContainer = styled.div(
  ({ theme }) => `
  display: none;

  ${MEDIA_QUERIES(theme).large}{
    display: block;
    position: sticky;
    top: -2rem;
    background-color: ${colors.grey.light5};
    z-index: ${zIndexRegistry.QUICK_FILTERS};
    margin: 0 -1rem; // workaround to cover the listing card on-hover shadow spilling over the container
    padding: 0 1rem;
  }
`
)

const filterCountSize = '2.5rem'

export const FilterCountBadge = styled(Flex)(
  ({ theme }) => `
  height: ${filterCountSize};
  width: ${filterCountSize};
  border-radius: ${theme.borderRadius.rounded};
  background-color: ${theme.colors.grey.light5};
  color: ${theme.colors.purple.primary};
  border: 0.2rem solid ${theme.colors.purple.primary};
  position: absolute;
  top: -0.9rem;
  right: -0.9rem;
  ${styleFromTypography(typography.body.xSmall)}
`
)
